import { Component } from '@angular/core';

@Component({
  selector: 'app-complete-page',
  templateUrl: './complete-page.component.html',
  styleUrl: './complete-page.component.scss'
})
export class CompletePageComponent {

}
